import { pickBy } from 'lodash'
import { stringify } from 'qs'

import { isFalsy } from '../../core/utils'

import { httpService } from '../../common/services'

const generateMetadataNodesGroupedByTypeReport = ({ metadataTypes }) => {
  const queryString = stringify(
    pickBy(
      {
        metadataTypes,
      },
      value => !isFalsy(value, { allowZero: true }),
    ),
    {
      addQueryPrefix: true,
      encode: true,
    },
  )

  return httpService.client.get(
    `/reports/metadataNodesGroupedByType${queryString}`,
    {
      responseType: 'blob',
    },
  )
}

export default generateMetadataNodesGroupedByTypeReport
